import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import MeditationIcon1 from '../assets/meditation icon1.svg';
import SleepIcon from '../assets/sleeping icon.svg';
import BreathingIcon from '../assets/breathing icon.svg';
import MeditationIcon2 from '../assets/meditation icon2.svg';

export default function QuieterMind() {
  return (
    <Box
      id="features"
      sx={{
        height: 'auto',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#FAFAFA',
        pt: 8,
       
      }}
    >
      <Container maxWidth="xl">
        {/* Section Title */}
        <Box
          sx={{
            textAlign: 'center',
            mb: { xs: 2, sm: 2, md: 8 },
            width: '100%',
          }}
        >
          <Typography
            variant="h2"
            sx={{
              fontFamily: "'Poppins', sans-serif",
              fontWeight: 700,
              fontSize: { xs: '28px', sm: '32px', md: '40px' },
              lineHeight: { xs: '34px', md: '40px' },
              letterSpacing: '-0.9px',
              color: '#325D44',
            }}
          >
            Gentle tools for a quieter mind.
          </Typography>
        </Box>

        {/* Cards Container */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', lg: 'repeat(4, 1fr)' },
            gap: '20px',
            width: '100%',
            py: 2,
            pl:"5px",
            pr:"5px",
          }}
        >
          {/* Card 1: Guided Meditation */}
          <Box
            sx={{
              width: '100%',
              height: { xs: 'auto', sm: '420px', md: '400px' },
              backgroundColor: '#FFFFFF',
              borderRadius: '12px',
              border: '1px solid rgba(50, 93, 68, 0.08)',
              boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.04)',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              overflow: 'hidden',
              flexShrink: 0,
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              '@media (hover: hover)': {
                '&:hover': {
                  transform: 'translateY(-8px)',
                  boxShadow: '0px 20px 40px rgba(50, 93, 68, 0.12)',
                  borderColor: 'rgba(50, 93, 68, 0.2)',
                },
              },
            }}
          >
            {/* Icon Background */}
            <Box
              sx={{
                width: '100%',
                height: { xs: '180px', sm: '200px', md: '211px' },
                backgroundColor: '#E8F5E9',
                borderTopLeftRadius: '12px',
                borderTopRightRadius: '12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {/* Meditation Icon */}
              <Box
                component="img"
                src={MeditationIcon1}
                alt="Guided Meditation"
                sx={{
                  width: { xs: '140px', sm: '160px', md: '174px' },
                  height: { xs: '140px', sm: '160px', md: '174px' },
                }}
              />
            </Box>
            {/* Card Content */}
            <Box
              sx={{
                p: 3,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
                flex: 1,
                justifyContent: 'center',
              }}
            >
              <Typography
                sx={{
                  fontFamily: "'Poppins', sans-serif",
                  fontWeight: 700,
                  fontStyle: 'bold',
                  fontSize: '20px',
                  lineHeight: '20px',
                  letterSpacing: '0%',
                  textAlign: 'center',
                  verticalAlign: 'middle',
                  mb: 2,
                  color: '#325D44',
                }}
              >
                Guided Meditation
              </Typography>
              <Typography
                sx={{
                  fontFamily: "'Poppins'",
                  fontWeight: 400,
                  fontStyle: 'normal',
                  fontSize: '12px',
                  lineHeight: '20px',
                  letterSpacing: '0%',
                  textAlign: 'center',
                  verticalAlign: 'middle',
                  color: '#657069',
                }}
              >
                Step into calm with expert-led sessions designed to relax your mind and restore focus. Whether you're a beginner or experienced, guided meditation helps reduce stress, improve clarity.
              </Typography>
            </Box>
          </Box>

          {/* Card 2: Sleep Support */}
          <Box
            sx={{
              width: '100%',
              height: { xs: 'auto', sm: '420px', md: '400px' },
              backgroundColor: '#FFFFFF',
              borderRadius: '12px',
              border: '1px solid rgba(50, 93, 68, 0.08)',
              boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.04)',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              overflow: 'hidden',
              flexShrink: 0,
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              '@media (hover: hover)': {
                '&:hover': {
                  transform: 'translateY(-8px)',
                  boxShadow: '0px 20px 40px rgba(50, 93, 68, 0.12)',
                  borderColor: 'rgba(50, 93, 68, 0.2)',
                },
              },
            }}
          >
            {/* Icon Background */}
            <Box
              sx={{
                width: '100%',
                height: { xs: '180px', sm: '200px', md: '211px' },
                backgroundColor: '#F3E5F5',
                borderTopLeftRadius: '12px',
                borderTopRightRadius: '12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {/* Sleep Icon */}
              <Box
                component="img"
                src={SleepIcon}
                alt="Sleep Support"
                sx={{
                  width: { xs: '140px', sm: '160px', md: '174px' },
                  height: { xs: '140px', sm: '160px', md: '174px' },
                }}
              />
            </Box>
            {/* Card Content */}
            <Box
              sx={{
                p: 3,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
                flex: 1,
                justifyContent: 'center',
              }}
            >
              <Typography
                sx={{
                  fontFamily: "'Poppins', sans-serif",
                  fontWeight: 700,
                  fontStyle: 'bold',
                  fontSize: '20px',
                  lineHeight: '20px',
                  letterSpacing: '0%',
                  textAlign: 'center',
                  verticalAlign: 'middle',
                  mb: 2,
                  color: '#325D44',
                }}
              >
                Sleep Support
              </Typography>
              <Typography
                sx={{
                  fontFamily: "'Poppins', sans-serif",
                  fontWeight: 400,
                  fontStyle: 'normal',
                  fontSize: '12px',
                  lineHeight: '20px',
                  letterSpacing: '0%',
                  textAlign: 'center',
                  verticalAlign: 'middle',
                  color: '#657069',
                }}
              >
                Step into calm with expert-led sessions designed to relax your mind and restore focus. Whether you're a beginner or experienced, guided meditation helps reduce stress, improve clarity.
              </Typography>
            </Box>
          </Box>

          {/* Card 3: Breathing Exercises */}
          <Box
            sx={{
              width: '100%',
              height: { xs: 'auto', sm: '420px', md: '400px' },
              backgroundColor: '#FFFFFF',
              borderRadius: '12px',
              border: '1px solid rgba(50, 93, 68, 0.08)',
              boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.04)',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              overflow: 'hidden',
              flexShrink: 0,
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              '@media (hover: hover)': {
                '&:hover': {
                  transform: 'translateY(-8px)',
                  boxShadow: '0px 20px 40px rgba(50, 93, 68, 0.12)',
                  borderColor: 'rgba(50, 93, 68, 0.2)',
                },
              },
            }}
          >
            {/* Icon Background */}
            <Box
              sx={{
                width: '100%',
                height: { xs: '180px', sm: '200px', md: '211px' },
                backgroundColor: '#E3F2FD',
                borderTopLeftRadius: '12px',
                borderTopRightRadius: '12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {/* Breathing Icon */}
              <Box
                component="img"
                src={BreathingIcon}
                alt="Breathing Exercises"
                sx={{
                  width: { xs: '140px', sm: '160px', md: '174px' },
                  height: { xs: '140px', sm: '160px', md: '174px' },
                }}
              />
            </Box>
            {/* Card Content */}
            <Box
              sx={{
                p: 3,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
                flex: 1,
                justifyContent: 'center',
              }}
            >
              <Typography
                sx={{
                  fontFamily: "'Poppins', sans-serif",
                  fontWeight: 700,
                  fontStyle: 'bold',
                  fontSize: '20px',
                  lineHeight: '20px',
                  letterSpacing: '0%',
                  textAlign: 'center',
                  verticalAlign: 'middle',
                  mb: 2,
                  color: '#325D44',
                }}
              >
                Breathing Exercises
              </Typography>
              <Typography
                sx={{
                  fontFamily: "'Poppins', sans-serif",
                  fontWeight: 400,
                  fontStyle: 'normal',
                  fontSize: '12px',
                  lineHeight: '20px',
                  letterSpacing: '0%',
                  textAlign: 'center',
                  verticalAlign: 'middle',
                  color: '#657069',
                }}
              >
                Step into calm with expert-led sessions designed to relax your mind and restore focus. Whether you're a beginner or experienced, guided meditation helps reduce stress, improve clarity.
              </Typography>
            </Box>
          </Box>

          {/* Card 4: Daily Mindfulness */}
          <Box
            sx={{
              width: '100%',
              height: { xs: 'auto', sm: '420px', md: '400px' },
              backgroundColor: '#FFFFFF',
              borderRadius: '12px',
              border: '1px solid rgba(50, 93, 68, 0.08)',
              boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.04)',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              overflow: 'hidden',
              flexShrink: 0,
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              '@media (hover: hover)': {
                '&:hover': {
                  transform: 'translateY(-8px)',
                  boxShadow: '0px 20px 40px rgba(50, 93, 68, 0.12)',
                  borderColor: 'rgba(50, 93, 68, 0.2)',
                },
              },
            }}
          >
            {/* Icon Background */}
            <Box
              sx={{
                width: '100%',
                height: { xs: '180px', sm: '200px', md: '211px' },
                backgroundColor: '#E8F5E9',
                borderTopLeftRadius: '12px',
                borderTopRightRadius: '12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {/* Mindfulness Icon */}
              <Box
                component="img"
                src={MeditationIcon2}
                alt="Daily Mindfulness"
                sx={{
                  width: { xs: '140px', sm: '160px', md: '174px' },
                  height: { xs: '140px', sm: '160px', md: '174px' },
                }}
              />
            </Box>
            {/* Card Content */}
            <Box
              sx={{
                p: 3,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
                flex: 1,
                justifyContent: 'center',
              }}
            >
              <Typography
                sx={{
                  fontFamily: "'Poppins', sans-serif",
                  fontWeight: 700,
                  fontStyle: 'bold',
                  fontSize: '20px',
                  lineHeight: '20px',
                  letterSpacing: '0%',
                  textAlign: 'center',
                  verticalAlign: 'middle',
                  mb: 2,
                  color: '#325D44',
                }}
              >
                Daily Mindfulness
              </Typography>
              <Typography
                sx={{
                  fontFamily: "'Poppins', sans-serif",
                  fontWeight: 400,
                  fontStyle: 'normal',
                  fontSize: '12px',
                  lineHeight: '18px',
                  letterSpacing: '0%',
                  textAlign: 'center',
                  verticalAlign: 'middle',
                  color: '#657069',
                }}
              >
                Step into calm with expert-led sessions designed to relax your mind and restore focus. Whether you're a beginner or experienced, guided meditation helps reduce stress, improve clarity.
              </Typography>
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
